module.exports = __webpack_public_path__ + "static/media/ic_perm_device_information_white_48px.ce5f7cc9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ic_perm_device_information_white_48px.svg
// module id = 799
// module chunks = 0